import React, { useState } from "react";
import "../auth.scss";
import { logodarkimg, logoimg } from "../../../assets/images";
import { FaArrowRightLong, FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useSnackbar from "../../../hooks/useSnackbar";
import { AuthService } from "../../../services";
import { useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import { resetPasswordValidation } from "../../../validations";
import { useMutation } from "@tanstack/react-query";
import ButtonLoader from "../../../component/buttonLoader";
import { Helmet } from "react-helmet";

const ResetPassword = () => {
  const location = useLocation();
  const email = location.state?.email;
  const mobile = location.state?.mobile;
  const countryCode = location.state?.countryCode;
  const [changePassword, setChangePassword] = useState(true);
  const changeIcon = !changePassword;

  const [changePasswords, setChangePasswords] = useState(true);
  const changeIcons = !changePasswords;

  const navigate = useNavigate();
  const { snackbar } = useSnackbar();
  const { resetPassword } = AuthService();
  const {
    register,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(resetPasswordValidation),
    defaultValues: {
      newPassword: "",
      confirmPassword: "",
    },
  });

  const resetPasswordMutation = useMutation({
    mutationFn: (data) => {
      return resetPassword({
        ...(email && { email }),
        ...(mobile && { mobile }),
        ...(countryCode && { countryCode }),
        ...data,
        type: "otp",
      });
    },
    onSuccess: (data) => {
      navigate("/login");
      snackbar(data?.message || "", "info");
    },
    onError: (err) => {
      snackbar(err.data.message || "");
    },
  });

  return (
    <>
      <Helmet defer={false}>
        <title>Reset Password | Holypills Account Recovery</title>
        <meta
          name="description"
          content="Forgot your Holypills password? Recover your account securely and regain access to your personalized health dashboard."
        />
        <meta property="og:image" content="/src/assets/images/ogImage.jpg" />
        <meta name="twitter:image" content="/src/assets/images/ogImage.jpg" />
        <link rel="canonical" href="https://holypills.in/reset" />

        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Reset Password | Holypills Account Recovery"
        />
        <meta
          property="og:description"
          content="Forgot your Holypills password? Recover your account securely and regain access to your personalized health dashboard."
        />

        <meta property="og:url" content="https://holypills.in/reset" />
        <meta property="og:site_name" content="Holypills"></meta>

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Reset Password | Holypills Account Recovery"
        />
        <meta
          name="twitter:description"
          content="Forgot your Holypills password? Recover your account securely and regain access to your personalized health dashboard."
        />

        <meta name="twitter:url" content="https://holypills.in/reset"></meta>
      </Helmet>
      <div className="wrapper_auth wrapper_Otp">
        <div className="wrap_left">
          <Link to={"/"}>
            <img src={logoimg} alt="logo" />
          </Link>
          <h1>
            Balance Your Body, <span></span> Empower Your Mind
          </h1>
        </div>
        <div className="wrap_right">
          <img className="logo" src={logodarkimg} alt="logo" />
          <h2>Reset Password</h2>
          <p className="mail_code">
            Create a password with at least 6 letters or Create a password with
            at least 6 letters or guess.
          </p>
          <div className="wrapper_cstm_tabers">
            <div className="signup_wrap">
              <form onSubmit={handleSubmit(resetPasswordMutation.mutate)}>
                <div className="form_field icon_set">
                  <input
                    type={changePassword ? "password" : "text"}
                    className="input form-control"
                    placeholder="Enter your password..."
                    {...register("newPassword")}
                  />
                  <span
                    onClick={() => {
                      setChangePassword(changeIcon);
                    }}
                  >
                    {changeIcon ? <FaRegEyeSlash /> : <FaRegEye />}
                  </span>
                  {errors.newPassword?.message && (
                    <span className="error">{errors.newPassword?.message}</span>
                  )}
                </div>
                <div className="form_field icon_set">
                  <input
                    type={changePasswords ? "password" : "text"}
                    className="input form-control"
                    placeholder="Confirm password..."
                    {...register("confirmPassword")}
                  />
                  <span
                    onClick={() => {
                      setChangePasswords(changeIcons);
                    }}
                  >
                    {changeIcons ? <FaRegEyeSlash /> : <FaRegEye />}
                  </span>
                  {errors.confirmPassword?.message && (
                    <span className="error">
                      {errors.confirmPassword?.message}
                    </span>
                  )}
                </div>

                <div className="btn_wrap_login">
                  <ButtonLoader
                    text={
                      <>
                        Set Password <FaArrowRightLong />
                      </>
                    }
                    className="login"
                    isLoading={resetPasswordMutation.isPending}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
